module.exports = __webpack_public_path__ + "media/images/property_photo4-fdf0888c.jpg";